// Base URL of the TDC cube server. NEXT_PUBLIC_* vars are inlined at BUILD time,
// so the deploy that builds the app must set NEXT_PUBLIC_TDC_API_URL; otherwise
// the Railway production fallback below is baked in.
export const TDC_API_BASE =
  process.env.NEXT_PUBLIC_TDC_API_URL ||
  'https://tdc-cube-production.up.railway.app';
